import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function card(theme: Theme): ComponentStyle {
  return {
    componentName: 'card',
    baseStyle: {
      transition: 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)'
    },
    variants: {
      chartKpiCard: {
        background: theme.colors.foreground,
        padding: `${theme.space['2xs']} ${theme.space['xs']}`
      },
      nested: {
        background: theme.colors.foreground,
        padding: `${theme.space['xs']} ${theme.space['s']}`
      },
      asyncKpiCard: {
        padding: 0,
        background: 'unset'
      },
      bannerStandout: {
        background: theme.colors.foreground,
        flex: 0
      },
      nestedAsChild: {
        background: 'unset',
        padding: 0
      },
      nestedExpandable: {
        border: `solid 1px ${theme.colors.border}`
      }
    }
  };
}
